import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Button,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, Link } from "react-router-dom";
import logo from "../assets/Final-logo.png";

export default function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Detect current active route
  const location = useLocation();
  const currentPath = location.pathname;

  const pages = [
    { title: "Home", path: "/" },
    { title: "About Us", path: "/about-us" },
    { title: "Contact Us", path: "/contact-us" },
  ];

  return (
    <AppBar position="fixed" color="inherit" sx={{ boxShadow: 1}}>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent : "space-around",
          p: 2,
        }}
      >
        {/* Logo */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            alt="Matrimony"
            style={{
              width: "100%",
              maxWidth: "110px",
              height: "70px",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* Desktop Menu */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 3 }}>
          {pages.map((p) => (
            <Button
              key={p.path}
              component={Link}
              to={p.path}
              sx={{
                color: currentPath === p.path ? "#BF0603" : "black",
                fontWeight: currentPath === p.path ? 700 : 500,
                fontFamily: "Quicksand",
                borderBottom:
                  currentPath === p.path ? "2px solid #BF0603" : "0px",
                borderRadius: 0,
              }}
            >
              {p.title}
            </Button>
          ))}
        </Box>

        {/* Mobile Menu Icon */}
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton onClick={() => setDrawerOpen(true)}>
            <MenuIcon />
          </IconButton>
        </Box>

        {/* Drawer for Mobile */}
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <Box sx={{ width: 260, p: 2 }}>
            <List>
              {pages.map((p) => (
                <ListItemButton
                  key={p.path}
                  component={Link}
                  to={p.path}
                  onClick={() => setDrawerOpen(false)}
                  sx={{
                    background: currentPath === p.path ? "#FFF1F1" : "#fff",
                    borderLeft:
                      currentPath === p.path ? "4px solid #BF0603" : "0",
                  }}
                >
                  <ListItemText
                    primary={p.title}
                    primaryTypographyProps={{
                      fontFamily: "Quicksand",
                      color: currentPath === p.path ? "#BF0603" : "black",
                      fontWeight: currentPath === p.path ? 700 : 500,
                    }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}
